import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { filter, take, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { UiService } from '../../core/services/ui.service';
import { AuthService, UserProfile } from '../../core/services/auth.service';

@Component({
  standalone: true,
  selector: 'app-home-page',
  imports: [CommonModule],
  template: `<div class="set-password-host" aria-hidden="true"></div>`,
})
export class HomePageComponent implements OnInit, OnDestroy {
  private readonly ui = inject(UiService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly auth = inject(AuthService);
  private readonly destroy$ = new Subject<void>();

  private startUrl = '';

  ngOnInit(): void {
    this.startUrl = this.router.url;

    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      const token = params['token'];
      if (!token) return;

      let context: 'reset' | 'registration' = 'registration';
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (payload?.flowType === 'reset') {
          context = 'reset';
        }
      } catch (err) {}

      this.ui.openCreatePasswordModal(token, context);
    });

    this.ui.createPasswordModal$
      .pipe(
        filter((modal) => !modal.visible),
        take(1),
        takeUntil(this.destroy$),
      )
      .subscribe(() => {
        if (this.startUrl.startsWith('/set-password') && this.router.url.startsWith('/set-password')) {
          this.navigateAfterSetPassword();
        }
      });
  }

  private navigateAfterSetPassword(): void {
    if (!this.auth.isAuthenticated) {
      this.router.navigateByUrl('/course-catalog', { replaceUrl: true });
      return;
    }

    // Ensure we route correctly for admin roles even if UI mode is learner
    this.auth.userProfile$.pipe(take(1)).subscribe((profile: UserProfile | null) => {
      const role = (profile?.role ?? '').toString().trim().toLowerCase();
      const isSuperAdmin = role === 'superadmin';
      const isSupportAdmin = role === 'supportadmin';

      const dest = isSuperAdmin || isSupportAdmin ? '/user-management' : '/dashboard';
      this.router.navigateByUrl(dest, { replaceUrl: true });
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
